import { SelectOptions } from '../../shared/form/inputs/Select';

export type BuildTypeCode = 'NewBuild' | 'Retrofit';

export const allBuildTypes: ReadonlyArray<BuildTypeCode> = ['NewBuild', 'Retrofit'] as const;

export const buildTypeDisplayNames: { [buildTypeCode in BuildTypeCode]: string } = {
  NewBuild: 'New Build',
  Retrofit: 'Retrofit',
};

export const buildTypeSelectOptions: SelectOptions<BuildTypeCode> = allBuildTypes.map(buildTypeCode => ({
  value: buildTypeCode,
  text: buildTypeDisplayNames[buildTypeCode],
}));
